import { createContext, type PropsWithChildren, useContext } from 'react'

import { useFeatureFlags } from '@/providers/hooks/useFeatureFlags'

type FeatureFlagsContextValue = {
  isFeatureEnabled: (flag: string) => boolean
}

const FeatureFlagsContext = createContext<FeatureFlagsContextValue | null>(null)

export const FeatureFlagsProvider = ({ children }: PropsWithChildren) => {
  const { isFeatureEnabled } = useFeatureFlags()

  return (
    <FeatureFlagsContext.Provider value={{ isFeatureEnabled }}>
      {children}
    </FeatureFlagsContext.Provider>
  )
}

export const useFeatureFlag = (flag: string) => {
  const context = useContext(FeatureFlagsContext)

  if (context === null) {
    throw new Error('useFeatureFlag must be used within a FeatureFlagsProvider')
  }

  return {
    isFeatureEnabled: context.isFeatureEnabled(flag),
  }
}
